module.exports = __webpack_public_path__ + "static/media/cole_turner.ffe8386b.jpg";